import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { UserStatus } from 'src/app/enums/user.status';
import { VerificationType } from 'src/app/enums/verification.type';
import { AgentApplication } from 'src/app/model/agent.application';
import { Pagination } from 'src/app/model/Pagination';
import { CommonService } from 'src/app/services/common.service';
import { StorageConstant } from 'src/app/settings/storage-constants';
import { URI } from 'src/app/settings/uri-constants';
import { AgentService } from './../../../services/agent.service';

@Component({
    selector: 'app-active-applications',
    templateUrl: './active-applications.component.html',
    styleUrls: ['./active-applications.component.css'],
})
export class ActiveApplicationsComponent implements OnInit {
    applicationList: Array<AgentApplication> = [];
    pagination = new Pagination();
    form: FormGroup;
    name = '';
    agentApplication: AgentApplication;
    denyModalDisplay = 'none';
    verifyModalDisplay = 'none';
    messageList = ['Failed interview', 'Cannot verify user documents', 'Failed training'];

    constructor(
        private commonService: CommonService,
        private agentService: AgentService,
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this.pagination.isAgent = true;
        this.form = this.formBuilder.group({
            role: ['agent'],
            status: [UserStatus.pending_review],
            start: ['0'],
            length: ['10'],
            isAgent: [true],
        });
    }

    ngOnInit() {
        this.getData();
    }

    getData() {
        this.form.get('start').setValue(this.pagination.start);
        this.form.get('length').setValue(this.pagination.length);
        this.agentService.getAgentApplications(this.form).subscribe({
            next: (application) => {
                setTimeout(() => {
                    this.applicationList = application?.responseBody?.data;
                    this.pagination.total = application?.responseBody?.resultTotal;
                }, 350);
            },
            error: (error) => {
            },
        });
    }

    receiveFilter(data: { name: string; value: number }) { }

    changeLength(len: number) {
        this.pagination.length = len;
        this.pagination.start = 0;
        this.getData();
    }

    changePage(page: number) {
        this.pagination.changePage(page);
        this.getData();
    }

    openDenyOption() {
        this.denyModalDisplay = 'block';
    }

    closeDenyOption() {
        this.denyModalDisplay = 'none';
    }

    openVerifyModal() {
        this.verifyModalDisplay = 'block';
    }

    closeVerifyModal() {
        this.verifyModalDisplay = 'none';
    }

    changeStatus(val: { type: string; agentApplication: AgentApplication }) {
        if (!val?.agentApplication) {
            console.error('changeStatus called with invalid payload:', val);
            return;
        }

        this.agentApplication = val.agentApplication;

        console.log('changeStatus type:', val.type);
        console.log('application keys:', Object.keys(this.agentApplication as any));
        console.log('application:', this.agentApplication);

        if (val.type === 'deny') {
            this.openDenyOption();
            return;
        }

        if (val.type === 'verify') {
            // Guard fullName
            const fullName =
                (this.agentApplication as any).fullName ??
                (this.agentApplication as any).name ??
                '';

            if (!fullName) {
                console.warn(
                    'No fullName on agentApplication. Check API field name.',
                    this.agentApplication,
                );
            }

            this.name = fullName;
            this.openVerifyModal();
            return;
        }

        try {
            localStorage.setItem(
                StorageConstant.AGENT_FILES,
                JSON.stringify(this.agentApplication),
            );
        } catch (e) {
            console.error(
                'Failed to store agent application in localStorage:',
                e,
                this.agentApplication,
            );
            return;
        }

        this.router.navigate([URI.getRouteNavPath('adminAgentApplicationsActiveFiles')]);
    }

    denyApplication() {
        const messageId = this.document
            .querySelector('input[name="operationType"]:checked')
            .attributes.getNamedItem('value').value;
        this.commonService
            .updateUserDocumnets(
                {
                    status: UserStatus.disabled,
                    statusMessage: this.messageList[messageId],
                    verificationType: VerificationType.residence,
                },
                this.agentApplication.userId,
            )
            .subscribe(
                (res) => {
                    if (res.success === true) {
                        this.getData();
                    }
                    this.closeDenyOption();
                },
                (err) => {
                    this.closeDenyOption();
                },
            );
    }

    approve() {
        localStorage.setItem(StorageConstant.AGENT_APPROVE, JSON.stringify(this.agentApplication));
        this.router.navigate([URI.SLASHED_ADD_AGENT]);
    }

    get controls(): any {
        return this.form.controls;
    }
}
